import * as Yup from "yup";
import { TStep } from "../types";
import { indivdualOrganisation, methodOfContact, tellUsMoreOptions, yesNoUnsure } from "./questionOptions";
import { InformationalPopover } from "../../InformationalPopover/InformationalPopover";
import CourtReview from "../steps/court/CourtReview";

export const courtSteps: {
  [key: string]: TStep;
} = {
  "court-step-one": {
    title: "Going to court",
    type: "form",
    note: (
      <>
        <p style={{maxWidth: 700}}>
          If you have been charged or arrested in relation to environmental protest we may be able to help.
        </p>
        <p style={{maxWidth: 700}}>
          We need some information to help us consider your request and respond as quickly as possible. Please include the following information if relevant:
        </p>
        <p style={{maxWidth: 700}}>
          <ul>
            <li>Where and when were you protesting?</li>
            <li>Was the protest organised by a group? Were you protesting with others?</li>
            <li>What were you charged with?</li>
          </ul>
        </p>
        <InformationalPopover description="I’ve been charged with Obstructing Traffic (s6 of the Summary Offences Act) while participating in a protest organised by Concerned Citizens for Climate Action in Sydney on 2.2.22. I have received a CAN that says I have to attend the Downing Centre on 3 March 2022." />
      </>
    ),
    components: [
      {
        type: "textarea",
        name: "chargeDescription",
        // label: "What have you been charged with?",
        validation: Yup.string()
          .max(1000, "Over character limit")
          .required("Please write some details about what have you been charged with"),
      },
    ],
    next: "court-step-two",
    submit: false,
    stepNumber: "9.5",
    stepText: "Step 4 of 5",
    stepPath: "/apply/protest/court",
  },
  "court-step-two": {
    title: "Going to court",
    type: "form",
    note: " If you have been charged or arrested in relation to an environmental protest we may be able to help.",
    components: [
      {
        type: "date",
        name: "courtDate",
        label: "When is your court date?",
        validation: Yup.date(),
      },
      {
        type: "text",
        name: "courtLocation",
        label: "Court location",
        validation: Yup.string(),
      },
      {
        type: "radio",
        name: "bailConditions",
        label: "Do you have bail conditions?",
        options: yesNoUnsure,
        validation: Yup.string(),
      },
      {
        type: "textarea",
        name: "courtRelevantInfo",
        label: "Any other relevant information",
      },
    ],
    next: "court-step-three",
    previous: "court-step-one",
    submit: false,
    stepNumber: "9.5",
    stepText: "Step 4 of 5",
  },
  "court-step-three": {
    title: "Are you protesting as an individual or as part of an organisation?",
    type: "form",
    note: "We will use this information to contact you and to make sure we don’t have a conflict of interest, so we can help you with your concern.",
    components: [
      {
        type: "radio",
        name: "individualOrOrganisation",
        options: indivdualOrganisation,
        validation: Yup.string().required("Please select one"),
      },
      {
        type: "text",
        name: "organisationName",
        label: "Organisation name*",
        condition: { individualOrOrganisation: "organisation" },
        validation: Yup.string().when("individualOrOrganisation", {
          is: "organisation",
          then: Yup.string().required("Please enter Organisation Name"),
        }),
      },
      {
        type: "text",
        name: "contactFirstName",
        label: "Given name*",
        validation: Yup.string().required("Please enter given name"),
      },
      {
        type: "text",
        name: "contactLastName",
        label: "Your last name*",
        validation: Yup.string().required("Please enter last name"),
      },
      {
        type: "email",
        name: "contactEmail",
        label: "Email*",
        validation: Yup.string().required("Please enter valid email").email("Please enter valid email"),
      },
      {
        type: "date",
        name: "contactBirthDate",
        label: "Date of birth*",
        validation: Yup.date().required("Please enter date of birth"),
      },
      {
        type: "tel",
        name: "contactNumber",
        label: "Contact Number*",
        validation: Yup.string()
          .required("Please enter valid phone number, including area code")
          .matches(
            /^\(?([0-9]{3})\)?([0-9]{3})([0-9]{4})$/,
            "Please enter valid phone number, including area code"
          ),
      },
      {
        type: "address",
        name: "contactAddress",
        label: "Street Address",
      },
      {
        label: "Preferred method of contact",
        type: "select",
        options: methodOfContact,
        name: "preferredContactMethod",
      },
    ],
    next: (values) => {
      if (values.individualOrOrganisation === "individual") {
        return "court-step-four";
      } else return "court-step-review";
    },
    previous: "court-step-two",
    submit: false,
    stepNumber: "9.6",
    stepText: "Step 5 of 5",
  },
  "court-step-four": {
    title: "Tell us a bit about you",
    type: "form",
    note: `Select any of the following that apply to you. This information is optional. You do not have to answer these questions. Any answer you give will help us assess your application. Some of our services are provided with the support of government funding, this information will help us report on the services we provide.`,
    components: [
      {
        type: "checkbox",
        name: "tellUsMore",
        options: tellUsMoreOptions,
        label: "Do any of the following apply to you?",
        note: "Please select all that apply",
      },
    ],
    next: "court-step-review",
    previous: "court-step-three",
    submit: false,
    stepText: "Step 5 of 5",
    stepNumber: "9.4",
  },
  "court-step-review": {
    type: "form-content",
    title: "Review your Application",
    note: "Check that the details you’ve provided are correct, then submit your application. <br/><br/> We want you to know that we will treat your information confidentially in accordance with our legal obligations. By submitting your application, you have requested legal advice. You have not entered into a client agreement with EDO.",
    component: <CourtReview />,
    next: "/apply/court-thanks",
    previous: (values) => {
      if (values.individualOrOrganisation === "individual") {
        return "court-step-four";
      } else return "court-step-three";
    },
    submit: true,
    stepNumber: "",
    stepPath: "/apply/review",
  },
};
